import { render, staticRenderFns } from "./VehicleModelCreate.vue?vue&type=template&id=6c278336"
import script from "./VehicleModelCreate.vue?vue&type=script&lang=js"
export * from "./VehicleModelCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports